import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-notification-confirmation-dialog',
  templateUrl: './delete-notification-confirmation-dialog.component.html',
  styleUrls: []
})
export class DeleteNotificationConfirmationDialogComponent implements OnInit {

  text: string;

  constructor(
    public dialogRef: MatDialogRef<string>,
    @Inject(MAT_DIALOG_DATA) public data: number
  ) {
    this.text = data ? 'Sei sicuro di voler rimuovere la notifica?' : 'Sei sicuro di voler rimuovere tutte le notifiche?';
  }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }

}
